import { createAction } from '@reduxjs/toolkit'
import { createPromiseAction } from 'redux-saga-promise-actions'
import * as types from './types'

export const getSchoolOccupationByIdFailure = createAction(
  types.GET_SCHOOL_OCCUPATION_BY_ID_FAILURE
)

export const getSchoolContentCreatorsById = createAction(
  types.GET_SCHOOL_CONTENT_CREATORS_BY_ID
)
export const getSchoolContentCreatorsByIdSuccessful = createAction(
  types.GET_SCHOOL_CONTENT_CREATORS_BY_ID_SUCCESSFUL
)
export const getSchoolContentCreatorsByIdFailure = createAction(
  types.GET_SCHOOL_CONTENT_CREATORS_BY_ID_FAILURE
)

export const getSchoolAdministratorById = createAction(
  types.GET_SCHOOL_ADMINISTRATOR_BY_ID
)
export const getSchoolAdministratorByIdSuccessful = createAction(
  types.GET_SCHOOL_ADMINISTRATOR_BY_ID_SUCCESSFUL
)

export const getSchoolParentById = createAction(types.GET_SCHOOL_PARENT_BY_ID)
export const getSchoolParentByIdSuccessful = createAction(
  types.GET_SCHOOL_PARENT_BY_ID_SUCCESSFUL
)

export const getSchoolTeacherById = createAction(types.GET_SCHOOL_TEACHER_BY_ID)
export const getSchoolTeacherByIdSuccessful = createAction(
  types.GET_SCHOOL_TEACHER_BY_ID_SUCCESSFUL
)
export const getSchoolTeacherRSPA = createPromiseAction(
  types.GET_SCHOOL_TEACHER_RSPA
)()

export const getSchoolCoordinatorById = createAction(
  types.GET_SCHOOL_COORDINATOR_BY_ID
)
export const getSchoolCoordinatorByIdSuccessful = createAction(
  types.GET_SCHOOL_COORDINATOR_BY_ID_SUCCESSFUL
)

export const getSchoolOmbudsmanById = createAction(
  types.GET_SCHOOL_OMBUDSMAN_BY_ID
)
export const getSchoolOmbudsmanByIdSuccess = createAction(
  types.GET_SCHOOL_OMBUDSMAN_BY_ID_SUCCESS
)

export const getSchoolFinanceById = createAction(types.GET_SCHOOL_FINANCE_BY_ID)
export const getSchoolFinanceByIdSuccess = createAction(
  types.GET_SCHOOL_FINANCE_BY_ID_SUCCESS
)

export const getSchoolSecretaryById = createAction(
  types.GET_SCHOOL_SECRETARY_BY_ID
)
export const getSchoolSecretaryByIdSuccess = createAction(
  types.GET_SCHOOL_SECRETARY_BY_ID_SUCCESS
)

export const getSchoolNurseById = createAction(types.GET_SCHOOL_NURSE_BY_ID)
export const getSchoolNurseByIdSuccess = createAction(
  types.GET_SCHOOL_NURSE_BY_ID_SUCCESS
)

export const getSchoolPsychologistById = createAction(
  types.GET_SCHOOL_PSYCHOLOGIST_BY_ID
)
export const getSchoolPsychologistByIdSuccess = createAction(
  types.GET_SCHOOL_PSYCHOLOGIST_BY_ID_SUCCESS
)

export const updateLayoutSchool = createAction(types.UPDATE_LAYOUT_SCHOOL)
export const updateLayoutSchoolSuccessful = createAction(
  types.UPDATE_LAYOUT_SCHOOL_SUCCESSFUL
)
export const updateLayoutSchoolFailure = createAction(
  types.UPDATE_LAYOUT_SCHOOL_FAILURE
)

export const getSchools = createAction(types.GET_SCHOOLS)
export const getSchoolsSuccessful = createAction(types.GET_SCHOOLS_SUCCESSFUL)
export const getSchoolsFailure = createAction(types.GET_SCHOOLS_FAILURE)

export const switchSchool = createAction(types.SWITCH_SCHOOL)
export const switchSchoolSuccessful = createAction(
  types.SWITCH_SCHOOL_SUCCESSFUL
)
export const switchSchoolFailure = createAction(types.SWITCH_SCHOOL_FAILURE)

export const getSchoolConfig = createAction(types.GET_SCHOOL_CONFIG)
export const getSchoolConfigSuccessFul = createAction(
  types.GET_SCHOOL_CONFIG_SUCCESSFUL
)
export const getSchoolConfigFailure = createAction(
  types.GET_SCHOOL_CONFIG_FAILURE
)

export const changeSchoolConfig = createAction(types.CHANGE_SCHOOL_CONFIG)
export const changeSchoolConfigSuccessful = createAction(
  types.CHANGE_SCHOOL_CONFIG_SUCCESSFUL
)
export const changeSchoolConfigFailure = createAction(
  types.CHANGE_SCHOOL_CONFIG_FAILURE
)

export const clearSchoolConfig = createAction(types.CLEAR_SCHOOL_CONFIG)

export const selectedCurrentSchool = createAction(types.SELECTED_CURRENT_SCHOOL)
export const selectedCurrentSchoolSuccessful = createAction(
  types.SELECTED_CURRENT_SCHOOL_SUCCESSFUL
)
export const clearCurrentSchool = createAction(types.CLEAR_CURRENT_SCHOOL)
